import { useState, useEffect } from 'react';
import { 
  getTranslatedValueFromKey, 
  getTranslationKeyFromValue,
  categories, 
  getTranslatedCategories 
} from '../data/categories';
import { useTranslationReload } from './useTranslationReload';

/**
 * Hook personalizzato per gestire le traduzioni delle categorie
 * Forza il re-rendering quando cambia la lingua
 */
export const useCategoryTranslation = () => {
  const { t, i18n } = useTranslationReload();
  const [localCategories, setLocalCategories] = useState(categories);

  useEffect(() => {
    setLocalCategories(getTranslatedCategories());
  }, [t]);

  // Traduce un valore di categoria (può essere una singola stringa o un formato "main > sub > type")
  const translateCategory = (value: string): string => {
    if (!value) return '';
    
    // Se è una stringa con il formato "main > sub > type"
    if (value.includes(' > ')) {
      const parts = value.split(' > ');
      return parts.map(part => {
        // Verifica prima se il valore è una chiave di traduzione
        if (part.startsWith('categories.')) {
          return getTranslatedValueFromKey(part);
        }
        
        // Se non è una chiave, prova a cercarne una corrispondente
        const keyFromValue = getTranslationKeyFromValue(part);
        if (keyFromValue !== part && keyFromValue.startsWith('categories.')) {
          return getTranslatedValueFromKey(keyFromValue);
        }
        
        return part;
      }).join(' > ');
    } 
    // Se è una singola chiave di traduzione
    else if (value.startsWith('categories.')) {
      return getTranslatedValueFromKey(value);
    }
    // Se è un valore diretto che potrebbe avere una chiave
    else {
      const keyFromValue = getTranslationKeyFromValue(value);
      if (keyFromValue !== value && keyFromValue.startsWith('categories.')) {
        return getTranslatedValueFromKey(keyFromValue);
      }
    }
    
    return value;
  };

  // Converte un valore tradotto nella sua chiave di traduzione
  const getCategoryKey = (value: string): string => {
    return getTranslationKeyFromValue(value);
  };

  return {
    categories: localCategories,
    translateCategory,
    getCategoryKey,
    t,
    i18n
  };
};

export default useCategoryTranslation; 